import { Component, OnInit, ViewChild } from '@angular/core';
import { DspxCardSetBaseFormComponent, SpinnerService, DialogService, CoreService } from 'dspx-core';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { NAV_TAB_NUMBERS, PAGE_NUMBERS, SECTION_CODES, QUESTION_CODES, FILTER_QUESTION_CODES } from 'src/app/constants/app-data.constants';
import { ErrorLogGridFilterRequest } from 'src/app/interfaces/error-log-grid-filter-request.interface';
import { Mapper, MapperBuilder, TRANSFORM } from '../../helpers/mapper';

@Component({
  selector: 'app-error-log-list',
  templateUrl: './error-log-list.component.html',
  styleUrl: './error-log-list.component.scss'
})
export class ErrorLogListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.errorLogList,
      () => API_ENDPOINTS.dashboard.getErrorLogs,
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.errorLogListForm.logTypeFilter)
        .MapFrom(FILTER_QUESTION_CODES.errorLogListForm.createdTimeFilter, TRANSFORM.STRING_TO_DATE)
        .BuildMapper();
  }

  ngOnInit(): void { }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }
  filterData(event: any): void {
    const filterRequest = this.getFilterRequest();
    this.loadGridData(filterRequest);
  }
  
  private getFilterRequest(): ErrorLogGridFilterRequest {

    const errorLogFilterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.errorLogListForm.errorLogs,
      PAGE_NUMBERS.errorLogListForm.errorLogs,
      SECTION_CODES.errorLogListForm.errorLog,
      QUESTION_CODES.errorLogListForm.errorLogListFilter
    );

    let filterRequest: ErrorLogGridFilterRequest = this.filterQuestionToFilterModelMapper.Map(errorLogFilterModel);

    filterRequest.errorLogSearchTerm = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.errorLogListForm.errorLogs,
      PAGE_NUMBERS.errorLogListForm.errorLogs,
      SECTION_CODES.errorLogListForm.errorLog,
      QUESTION_CODES.errorLogListForm.errorLogSearchTerm
    );

    return filterRequest;
  }

}
